import { LoginResult } from '../models/api';

const setLoginInfo = (info: any) => {
  const loginInfo: LoginResult = info;
  sessionStorage.setItem('login-info', JSON.stringify(loginInfo));
};

const getLoginInfo = () => {
  const loginInfoString = sessionStorage.getItem('login-info');
  if (loginInfoString === null) return null;

  const loginInfo: LoginResult = JSON.parse(loginInfoString);

  return loginInfo;
};

const removeLoginInfo = () => {
  sessionStorage.removeItem('login-info');
};

export default {
  setLoginInfo,
  getLoginInfo,
  removeLoginInfo,
};
